import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { compose, withHandlers, withStateHandlers } from "recompose";
import { businessSelector } from '../../../../../state/modules/business';
import { ControlGroup, ControlOption } from '../../../../components';
import SearchForm from '../../../../components/search-form';
import { noCapMap } from '../../../../../utils';

const PublisherFilter = ({
  publishers,
  selectedPublishers,
  selectedBusinessId,
  selectAll,
  clearAll,
  changeHandler,
  show,
  searchQuery,
  updateSearchQuery,
  business
}) => (
    <div id='publisher-filter' className={`slide-panel ${show === undefined ? 'hide' : ''} ${show ? 'in' : 'out'}`}>
      <Row className='no-gutter'>
        <Col md={6} xs={12} className='right-padding-md bottom-padding-sm'>
          <Button onClick={selectAll} className='full'>Select All</Button>
        </Col>
        <Col md={6} xs={12} className='right-padding-md'>
          <Button onClick={clearAll} className='full'>Clear All</Button>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Col xs={12}>
          <SearchForm id='search-desktop' label='Search Publishers' className='searchDesktop' searchQuery={searchQuery} onSearchChange={updateSearchQuery} />
        </Col>
      </Row>
      <Row className='no-gutter'>
        <ControlGroup
          control='checkbox'
          type='styled'
          label={null}
          colProps={{ xs: 12 }}>
          {
            fp.flow(
              fp.filter(
                ({ name }) => fp.lowerCase(name).includes(fp.lowerCase(searchQuery))
              ),
              fp.sortBy(({ name }) => fp.lowerCase(name)),
              noCapMap(({ id, name, isBusiness }, index) => isBusiness ?
                <ControlOption
                  key={index}
                  value={id}
                  checked={selectedBusinessId === id}
                  onChange={(e) => changeHandler(e.target.value, isBusiness)}
                  label={<span>{he.decode(name)}</span>} /> :
                <ControlOption
                  key={index}
                  value={id}
                  checked={fp.contains(id, selectedPublishers)}
                  onChange={(e) => changeHandler(e.target.value, isBusiness)}
                  label={<span>{he.decode(name)}</span>} />
              )
            )(publishers.concat([{
              ...business,
              isBusiness: true
            }]))
          }
        </ControlGroup>
      </Row>
    </div>
  )

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  publishers: state.publisher.publishers
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    selectAll: ({ setAll, publishers, business }) => () => {
      setAll(fp.map(
        ({ id }) => id
      )(publishers), business.id)
    },
    clearAll: ({ setAll }) => () => {
      setAll([])
    }
  }),
  withStateHandlers(
    {
      searchQuery: ''
    },
    {
      updateSearchQuery: () => (e) => ({
        searchQuery: e.target.value
      })
    }
  )
)(PublisherFilter)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/publisher-filter.js